import * as React from 'react';

import { ProgressStateModel, EvalState, TicketState } from 'eTip--common';

import { TicketListStateIcon, ProgressContent } from 'common--design-library';

import { translationForMts, currencyFormatter, TimeFormat, dateFormatter, pointsFormatter } from 'easit--localization';
import classNames from 'classnames';


export interface ITodayTicketsItem {
    id: number;
    placementDate: Date;
    stake: number;
    stakePoints: number;
    potentialWin: number;
    evalState: EvalState;
    ticketState: TicketState;
    cashout: number;
}

export interface ITodayTicketsProps {
    tickets: ITodayTicketsItem[];
    state: ProgressStateModel;
    error: string;
    showLoadNext: boolean;

    onGoToDetail: (ticketId: string) => void;
    onReload: () => void;
    onLoadNext: () => void;
}

export const TodayTickets: React.FC<ITodayTicketsProps> = (props: ITodayTicketsProps) => {
    const t = translationForMts();

    return <div className="today-tickets-wrapper pb-2">
        {
            (props.tickets.length > 0) &&
            <table className="today-tickets-table w-100">
                <thead>
                    <tr>
                        <th>{t.betList_ColumnTime}</th>
                        <th className={__IsMTSTipos__ ? null : "text-right"}>{t.betList_ColumnStake}</th>
                        <th className={__IsMTSTipos__ ? null : "text-right"}>{t.myTickets_ColumnPotentialPrice}</th>
                        <th className={__IsMTSTipos__ ? "text-center" : "text-right"}>{t.betList_ColumnStatus}</th>
                        <th className="detail-col">{/*t.betList_ColumnDetail*/}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.tickets.map(ticket => <tr key={ticket.id} className="cursor-pointer" onClick={() => { props.onGoToDetail(`${ticket.id}`) }}>
                            <td>
                                {/* {dateFormatter.formatDateAsRelative(ticket.placementDate, DateFormat.DDMM)} <br /> */}
                                {dateFormatter.formatTime(ticket.placementDate, TimeFormat.HHMM)}
                            </td>
                            <td className={__IsMTSTipos__ ? null : "text-right"}>{currencyFormatter.format(ticket.stake)}{(ticket.stakePoints > 0) && <><br />{pointsFormatter.format(ticket.stakePoints)}</>}</td>
                            <td className={__IsMTSTipos__ ? null : "text-right"}>{currencyFormatter.format(ticket.potentialWin)}</td>
                            <td className={classNames("bet-state", __IsMTSTipos__ ? "text-center" : "text-right")}>
                                {
                                    ticket.cashout > 0
                                        ? <span className="state-icon fa fa-thumbs-up to-cashout" ></span>
                                        : <TicketListStateIcon ticketState={ticket.ticketState} evalState={ticket.evalState} />
                                }
                            </td>
                            <td className="detail-col"><span className="fa fa-search nav-link" ></span></td>
                        </tr>)
                    }
                </tbody>
            </table>
        }

        {
            <ProgressContent state={props.state} errorMessage={props.error}>
                {
                    props.tickets.length === 0 &&
                    <div className="p-1 text-center">
                        {t.rightColumn_NoBetsToday} <br />
                    </div>
                }
                <div className="p-1 text-center">
                    <button className="btn btn-primary mr-1" onClick={() => { props.onReload() }} data-test-role="today-tickets__reload">{t.rightColumn_LoadAgain}</button>
                    {
                        props.showLoadNext &&
                        <button className="btn btn-primary" onClick={() => { props.onLoadNext() }}>{t.next}</button>
                    }
                </div>
            </ProgressContent>
        }
    </div>
}